import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AppMessage } from 'src/app/models/app-message';
import { AuthService } from 'src/app/services/auth.service';
import { MainAppService } from 'src/app/services/main-app.service';
import { AppMessagesDetailComponent } from '../app-messages-detail/app-messages-detail.component';

@Component({
  selector: 'app-app-messages',
  templateUrl: './app-messages.component.html',
  styleUrls: ['./app-messages.component.css']
})
export class AppMessagesComponent implements OnInit {
  displayedColumns: string[] = ['langId', 'name', 'lastName', 'country', 'male', 'female', 'age' ,'email', 'idPassport', 'signatureError', 'signatureHeader', 'source','termsHeader','termsText', 'gdprHeader', 'gdprText'];
  dataSource :any =[];

  constructor(    
    public dialog: MatDialog,
    public mainAppService: MainAppService, 
    public auth: AuthService) {}

  ngOnInit(): void {
    this.search();
  }

  search() {
    this.mainAppService.getAppMessages().subscribe(retval => 
      {
        if (retval && retval.responseData){
          this.dataSource = new MatTableDataSource(retval.responseData)
        }
      });
  }

  showDetails(appMessage: AppMessage){
    this.dialog.open(AppMessagesDetailComponent, {
      width: '600px',
      height: '740px',
      data: appMessage
    });
  }
}
